
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
} = require('@prisma/client/runtime/index-browser')


const Prisma = {}

exports.Prisma = Prisma

/**
 * Prisma Client JS version: 5.0.0
 * Query Engine version: 6b0aef69b7cdfc787f822ecd7cdc76d5f1991584
 */
Prisma.prismaVersion = {
  client: "5.0.0",
  engine: "6b0aef69b7cdfc787f822ecd7cdc76d5f1991584"
}

Prisma.PrismaClientKnownRequestError = () => {
  throw new Error(`PrismaClientKnownRequestError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  throw new Error(`PrismaClientUnknownRequestError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientRustPanicError = () => {
  throw new Error(`PrismaClientRustPanicError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientInitializationError = () => {
  throw new Error(`PrismaClientInitializationError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientValidationError = () => {
  throw new Error(`PrismaClientValidationError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.NotFoundError = () => {
  throw new Error(`NotFoundError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  throw new Error(`sqltag is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.empty = () => {
  throw new Error(`empty is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.join = () => {
  throw new Error(`join is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.raw = () => {
  throw new Error(`raw is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  throw new Error(`Extensions.getExtensionContext is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.defineExtension = () => {
  throw new Error(`Extensions.defineExtension is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}

/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.LevityUserScalarFieldEnum = {
  id: 'id',
  email: 'email',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  levityWorkspaceId: 'levityWorkspaceId'
};

exports.Prisma.LevityWorkspaceScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  hasRunSignupProcedure: 'hasRunSignupProcedure'
};

exports.Prisma.LevityUserWorkspaceMappingScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  workspaceId: 'workspaceId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AiBlockScalarFieldEnum = {
  id: 'id',
  name: 'name',
  emoji: 'emoji',
  type: 'type',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  fronteggTenantId: 'fronteggTenantId',
  flowVersionId: 'flowVersionId'
};

exports.Prisma.AiBlockDataScalarFieldEnum = {
  id: 'id',
  text: 'text',
  type: 'type',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  aiBlockId: 'aiBlockId'
};

exports.Prisma.AiBlockMetaDataScalarFieldEnum = {
  id: 'id',
  key: 'key',
  value: 'value',
  type: 'type',
  labelSource: 'labelSource',
  requestSource: 'requestSource',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  aiBlockId: 'aiBlockId'
};

exports.Prisma.AiBlockTraitScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  type: 'type',
  isDisabled: 'isDisabled',
  isUserManaged: 'isUserManaged',
  aiBlockId: 'aiBlockId'
};

exports.Prisma.PromptScalarFieldEnum = {
  id: 'id',
  name: 'name',
  type: 'type',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  activeVersionCounter: 'activeVersionCounter',
  isActive: 'isActive'
};

exports.Prisma.PromptInstanceScalarFieldEnum = {
  id: 'id',
  text: 'text',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  versionCounter: 'versionCounter',
  promptId: 'promptId'
};

exports.Prisma.PromptMetadataScalarFieldEnum = {
  id: 'id',
  key: 'key',
  value: 'value',
  type: 'type',
  isDisabled: 'isDisabled',
  inputKey: 'inputKey',
  outputKey: 'outputKey',
  outputDataType: 'outputDataType',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  promptInstanceId: 'promptInstanceId'
};

exports.Prisma.CustomAuthKeysScalarFieldEnum = {
  type: 'type',
  key: 'key',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PaymentProvidersScalarFieldEnum = {
  id: 'id',
  type: 'type',
  apiKey: 'apiKey',
  secret: 'secret',
  apiHost: 'apiHost',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SubscriptionsScalarFieldEnum = {
  id: 'id',
  workspaceId: 'workspaceId',
  planId: 'planId',
  subscriptionId: 'subscriptionId',
  canceledAt: 'canceledAt',
  terminatedAt: 'terminatedAt',
  startedAt: 'startedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  nextBillingDate: 'nextBillingDate',
  status: 'status'
};

exports.Prisma.BillableMetricsScalarFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description',
  aggregationType: 'aggregationType',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  code: 'code'
};

exports.Prisma.PlansScalarFieldEnum = {
  id: 'id',
  name: 'name',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  interval: 'interval',
  description: 'description',
  amountCents: 'amountCents',
  amountCurrency: 'amountCurrency',
  trialPeriodDays: 'trialPeriodDays',
  payInAdvance: 'payInAdvance',
  display: 'display',
  code: 'code'
};

exports.Prisma.WorkspacePlanMappingScalarFieldEnum = {
  workspaceId: 'workspaceId',
  planId: 'planId',
  expiredAt: 'expiredAt',
  id: 'id',
  isEnterprise: 'isEnterprise'
};

exports.Prisma.WorkspacePlanChargesMappingScalarFieldEnum = {
  workspaceId: 'workspaceId',
  planChargeId: 'planChargeId',
  id: 'id',
  expiredAt: 'expiredAt'
};

exports.Prisma.PlanChargesScalarFieldEnum = {
  id: 'id',
  billableMetricId: 'billableMetricId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  planId: 'planId',
  amountCurrency: 'amountCurrency',
  chargeType: 'chargeType',
  amountCents: 'amountCents',
  packageSize: 'packageSize'
};

exports.Prisma.ConsumptionEventsScalarFieldEnum = {
  id: 'id',
  workspaceId: 'workspaceId',
  properties: 'properties',
  timestamp: 'timestamp',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  billableMetricCode: 'billableMetricCode',
  count: 'count'
};

exports.Prisma.ConsumptionLimitsScalarFieldEnum = {
  workspaceId: 'workspaceId',
  used: 'used',
  limit: 'limit',
  lastRecharged: 'lastRecharged',
  billableMetricCode: 'billableMetricCode'
};

exports.Prisma.RechargeHistoryScalarFieldEnum = {
  id: 'id',
  workspaceId: 'workspaceId',
  billableMetricCode: 'billableMetricCode',
  oldUsed: 'oldUsed',
  oldLimit: 'oldLimit',
  newLimit: 'newLimit',
  createdAt: 'createdAt'
};

exports.Prisma.AiBlockPredictionScalarFieldEnum = {
  id: 'id',
  isApproved: 'isApproved',
  source: 'source',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  aiBlockId: 'aiBlockId',
  metaDataId: 'metaDataId'
};

exports.Prisma.AiBlockPredictionMetaDataScalarFieldEnum = {
  id: 'id',
  type: 'type',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  predictionId: 'predictionId',
  value: 'value'
};

exports.Prisma.FlowScalarFieldEnum = {
  title: 'title',
  isActivated: 'isActivated',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  id: 'id',
  workspaceId: 'workspaceId'
};

exports.Prisma.FlowVersionScalarFieldEnum = {
  id: 'id',
  flowId: 'flowId',
  publishedAt: 'publishedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  isCurrentVersion: 'isCurrentVersion'
};

exports.Prisma.NodeInputReferenceScalarFieldEnum = {
  id: 'id',
  referenceKey: 'referenceKey',
  referenceKeyType: 'referenceKeyType',
  referenceCategory: 'referenceCategory',
  nodeInputId: 'nodeInputId',
  createdAt: 'createdAt'
};

exports.Prisma.NodeInputScalarFieldEnum = {
  id: 'id',
  nodeId: 'nodeId',
  operation: 'operation',
  key: 'key',
  rawValue: 'rawValue',
  parsedValue: 'parsedValue',
  connectedNodeInputId: 'connectedNodeInputId',
  connectedNodeId: 'connectedNodeId',
  createdAt: 'createdAt'
};

exports.Prisma.DynamicOutputKeyScalarFieldEnum = {
  id: 'id',
  name: 'name',
  code: 'code',
  default: 'default',
  rawName: 'rawName',
  connectedNodeId: 'connectedNodeId',
  provider: 'provider'
};

exports.Prisma.OutputTransformationSettingsScalarFieldEnum = {
  id: 'id',
  nodeId: 'nodeId',
  key: 'key',
  isSelected: 'isSelected',
  path: 'path',
  label: 'label'
};

exports.Prisma.FlowNodeScalarFieldEnum = {
  type: 'type',
  id: 'id',
  metadata: 'metadata',
  versionId: 'versionId',
  connectionId: 'connectionId'
};

exports.Prisma.FlowEdgeScalarFieldEnum = {
  sourceHandle: 'sourceHandle',
  targetHandle: 'targetHandle',
  id: 'id',
  sourceId: 'sourceId',
  targetId: 'targetId',
  versionId: 'versionId'
};

exports.Prisma.IntegrationAppAuthenticationsScalarFieldEnum = {
  id: 'id',
  integrationAuthApp: 'integrationAuthApp',
  name: 'name',
  workspaceId: 'workspaceId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AccountScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  type: 'type',
  provider: 'provider',
  providerAccountId: 'providerAccountId',
  refresh_token: 'refresh_token',
  access_token: 'access_token',
  expires_at: 'expires_at',
  token_type: 'token_type',
  scope: 'scope',
  id_token: 'id_token',
  session_state: 'session_state'
};

exports.Prisma.SessionScalarFieldEnum = {
  id: 'id',
  sessionToken: 'sessionToken',
  userId: 'userId',
  expires: 'expires'
};

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  name: 'name',
  email: 'email',
  emailVerified: 'emailVerified',
  image: 'image',
  isLocked: 'isLocked',
  levityUserId: 'levityUserId'
};

exports.Prisma.VerificationTokenScalarFieldEnum = {
  identifier: 'identifier',
  token: 'token',
  expires: 'expires'
};

exports.Prisma.FlowExecutionScalarFieldEnum = {
  id: 'id',
  flowVersionId: 'flowVersionId',
  status: 'status',
  startTime: 'startTime',
  endTime: 'endTime',
  error: 'error',
  tree: 'tree'
};

exports.Prisma.FlowNodeExecutionScalarFieldEnum = {
  id: 'id',
  flowExecutionId: 'flowExecutionId',
  nodeId: 'nodeId',
  status: 'status',
  startTime: 'startTime',
  endTime: 'endTime',
  output: 'output',
  retries: 'retries',
  error: 'error'
};

exports.Prisma.FlowPathScalarFieldEnum = {
  id: 'id',
  flowNodeId: 'flowNodeId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.FlowPathConditionGroupScalarFieldEnum = {
  id: 'id',
  flowPathId: 'flowPathId',
  logic: 'logic',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.FlowPathConditionScalarFieldEnum = {
  id: 'id',
  conditionGroupId: 'conditionGroupId',
  sourceNodeId: 'sourceNodeId',
  sourceOutputKey: 'sourceOutputKey',
  comparator: 'comparator',
  comparisonValueType: 'comparisonValueType',
  comparisonValue: 'comparisonValue',
  aiBlockMetaDataId: 'aiBlockMetaDataId',
  logic: 'logic',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.FlowHistoryLogScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  message: 'message',
  messageMetadata: 'messageMetadata',
  logLevel: 'logLevel',
  flowId: 'flowId',
  flowNodeId: 'flowNodeId',
  levityWorkspaceId: 'levityWorkspaceId'
};

exports.Prisma.FlowNodeWebhookCallScalarFieldEnum = {
  id: 'id',
  uuid: 'uuid',
  receivedAt: 'receivedAt',
  processed: 'processed',
  payload: 'payload'
};

exports.Prisma.FlowNodeCustomCodeScalarFieldEnum = {
  id: 'id',
  nodeId: 'nodeId',
  language: 'language',
  code: 'code',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.JsonNullValueInput = {
  JsonNull: Prisma.JsonNull
};

exports.Prisma.NullableJsonNullValueInput = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};
exports.AiBlockType = {
  extract: 'extract',
  classify: 'classify',
  generate: 'generate',
  summarize: 'summarize',
  custom: 'custom'
};

exports.AiBlockDataLabelType = {
  Label: 'Label',
  Trait: 'Trait'
};

exports.AiBlockMetaDataType = {
  DataLabel: 'DataLabel',
  AiBlockLabel: 'AiBlockLabel',
  TextStyle: 'TextStyle',
  Context: 'Context',
  AiBlockType: 'AiBlockType',
  SentenceLength: 'SentenceLength',
  EnforceSingleLabel: 'EnforceSingleLabel',
  LlmModel: 'LlmModel'
};

exports.AiBlockMetaDataSource = {
  UserAnnotated: 'UserAnnotated',
  OpenAI: 'OpenAI'
};

exports.AiBlockRequestSource = {
  Api: 'Api',
  Make: 'Make',
  Zapier: 'Zapier',
  InApp: 'InApp',
  FlowTest: 'FlowTest',
  FlowRun: 'FlowRun'
};

exports.AiBlockTraitType = {
  AutoLearnLabels: 'AutoLearnLabels'
};

exports.PromptMetadataType = {
  Trait: 'Trait'
};

exports.PromptMetadataOutputDataType = {
  Array: 'Array',
  String: 'String'
};

exports.CustomAuthKeyType = {
  Tenant: 'Tenant'
};

exports.PaymentProviderType = {
  Paddle: 'Paddle'
};

exports.SubscriptionStatus = {
  active: 'active',
  past_due: 'past_due',
  paused: 'paused',
  deleted: 'deleted'
};

exports.BillableMetricsAggregationType = {
  Count: 'Count'
};

exports.BillableMetricsCode = {
  actions_v1: 'actions_v1'
};

exports.PlanIntervals = {
  Weekly: 'Weekly',
  Monthly: 'Monthly',
  Yearly: 'Yearly'
};

exports.PlansCode = {
  startup_v1: 'startup_v1',
  business_v1: 'business_v1',
  free_v1: 'free_v1',
  startup_yearly_v1: 'startup_yearly_v1',
  business_yearly_v1: 'business_yearly_v1'
};

exports.PlanChargeType = {
  IncludedCharge: 'IncludedCharge',
  AdditionalCharge: 'AdditionalCharge',
  OnDemandCharge: 'OnDemandCharge',
  Freebie: 'Freebie'
};

exports.AiBlockPredictionMetadataType = {
  ClassifiedLabel: 'ClassifiedLabel',
  Summary: 'Summary',
  Generation: 'Generation',
  ExtractedData: 'ExtractedData',
  Custom: 'Custom'
};

exports.FlowNodeType = {
  APP: 'APP',
  AI_BLOCK: 'AI_BLOCK',
  PATH: 'PATH',
  WAIT: 'WAIT'
};

exports.IntegrationAuthApp = {
  gmailV1: 'gmailV1',
  gsheetsV1: 'gsheetsV1',
  zendeskV1: 'zendeskV1',
  freshdeskV1: 'freshdeskV1',
  freshserviceEnpal: 'freshserviceEnpal',
  hubspotV1: 'hubspotV1',
  microsoftTeams: 'microsoftTeams',
  microsoftTeamsV2: 'microsoftTeamsV2',
  frontV1: 'frontV1',
  slack: 'slack',
  network: 'network',
  webhook: 'webhook',
  customCode: 'customCode',
  development: 'development',
  gw: 'gw',
  microsoftEntra: 'microsoftEntra'
};

exports.FlowExecutionStatus = {
  RUNNING: 'RUNNING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  TERMINATED: 'TERMINATED'
};

exports.NodeExecutionStatus = {
  RUNNING: 'RUNNING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED'
};

exports.ConditionLogic = {
  AND: 'AND',
  OR: 'OR'
};

exports.ConditionComparator = {
  CONTAINS: 'CONTAINS',
  DOES_NOT_CONTAIN: 'DOES_NOT_CONTAIN',
  EQUALS: 'EQUALS',
  DOES_NOT_EQUAL: 'DOES_NOT_EQUAL',
  GREATER_THAN: 'GREATER_THAN',
  LESS_THAN: 'LESS_THAN',
  IS_EMPTY: 'IS_EMPTY',
  IS_NOT_EMPTY: 'IS_NOT_EMPTY'
};

exports.ComparisonValueType = {
  STRING: 'STRING',
  REFERENCE: 'REFERENCE'
};

exports.FlowHistoryLogLevel = {
  SYSTEM_INFO: 'SYSTEM_INFO',
  SYSTEM_WARN: 'SYSTEM_WARN',
  SYSTEM_EXCEPTION: 'SYSTEM_EXCEPTION',
  USER_INFO: 'USER_INFO',
  USER_WARN: 'USER_WARN',
  USER_EXCEPTION: 'USER_EXCEPTION'
};

exports.FlowNodeCustomCodeLanguage = {
  JS: 'JS'
};

exports.Prisma.ModelName = {
  LevityUser: 'LevityUser',
  LevityWorkspace: 'LevityWorkspace',
  LevityUserWorkspaceMapping: 'LevityUserWorkspaceMapping',
  AiBlock: 'AiBlock',
  AiBlockData: 'AiBlockData',
  AiBlockMetaData: 'AiBlockMetaData',
  AiBlockTrait: 'AiBlockTrait',
  Prompt: 'Prompt',
  PromptInstance: 'PromptInstance',
  PromptMetadata: 'PromptMetadata',
  CustomAuthKeys: 'CustomAuthKeys',
  PaymentProviders: 'PaymentProviders',
  Subscriptions: 'Subscriptions',
  BillableMetrics: 'BillableMetrics',
  Plans: 'Plans',
  WorkspacePlanMapping: 'WorkspacePlanMapping',
  WorkspacePlanChargesMapping: 'WorkspacePlanChargesMapping',
  PlanCharges: 'PlanCharges',
  ConsumptionEvents: 'ConsumptionEvents',
  ConsumptionLimits: 'ConsumptionLimits',
  RechargeHistory: 'RechargeHistory',
  AiBlockPrediction: 'AiBlockPrediction',
  AiBlockPredictionMetaData: 'AiBlockPredictionMetaData',
  Flow: 'Flow',
  FlowVersion: 'FlowVersion',
  NodeInputReference: 'NodeInputReference',
  NodeInput: 'NodeInput',
  DynamicOutputKey: 'DynamicOutputKey',
  OutputTransformationSettings: 'OutputTransformationSettings',
  FlowNode: 'FlowNode',
  FlowEdge: 'FlowEdge',
  IntegrationAppAuthentications: 'IntegrationAppAuthentications',
  Account: 'Account',
  Session: 'Session',
  User: 'User',
  VerificationToken: 'VerificationToken',
  FlowExecution: 'FlowExecution',
  FlowNodeExecution: 'FlowNodeExecution',
  FlowPath: 'FlowPath',
  FlowPathConditionGroup: 'FlowPathConditionGroup',
  FlowPathCondition: 'FlowPathCondition',
  FlowHistoryLog: 'FlowHistoryLog',
  FlowNodeWebhookCall: 'FlowNodeWebhookCall',
  FlowNodeCustomCode: 'FlowNodeCustomCode'
};

/**
 * Create the Client
 */
class PrismaClient {
  constructor() {
    throw new Error(
      `PrismaClient is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
    )
  }
}
exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
